<template>
    <default-item class="chi_chinese_new_years_item--container" :item="item" :pricing-types="pricingTypes"
                  layout="price-below" tag-location="after-title"></default-item>
</template>

<script lang="ts">
/**
 * Custom component for CHI Chinese New Year items.
 *
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 1.4.0
 * @copyright  Copyright (C) 2023-2026, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 * @changelog
 * 2026-02-17 (1.3.0) (jhoward)
 *   - Add new App\Library\Js\Components\Menu\Item\Chi_chineseNewYearItem.vue component for rendering Chinese New Year menu items in Chi.
 *   - Implements custom layout, props, and scoped styles for the new item type.
 *
 * 2026-07-20 (1.4.0) (jhoward)
 *   - Add App\Library\Js\Components\Menu\Item\Chi_chineseNewYearItem.vue for rendering Chinese New Year menu items in Chi.
 */

import {defineComponent, PropType} from "vue";
import {MENU_ITEM_LAYOUT, MenuItem} from "../defs";
import DefaultItem from "./defaultItem.vue";

export default defineComponent({
  name: 'chi-chinese-new-year-item',
  components: {
    DefaultItem
  },
  props: {
    item: {
      type: Object as PropType<MenuItem>,
      required: true
    },
    pricingTypes: {
      type: Array as PropType<string[]>,
      default: () => []
    },
    priceLayout: {
      type: String as PropType<MENU_ITEM_LAYOUT>,
      default: ''
    }
  },
})
</script>

<style scoped>
html .chi_chinese_new_years_item--container.menu--item {
  display: block;
  text-align: center;
}

.visual_menu--container .chi_chinese_new_years_item--container.menu--item {
  font-size: 1.4em;
}

.chi_chinese_new_years_item--container:deep(.menu--item_title > span) {
  display: block;
}

.chi_chinese_new_years_item--container:deep(.menu--item_subtitle) {
  font-weight: normal;
}
</style>